import { sortEventBatchesByStartDateAsc } from './sortEventBatchesByStartDateDesc.js';

/** Admin registrations: batches until camp end date (includes closed/inactive). */
export function registrationBatchListParams(extra = {}) {
  return {
    sortBy: 'startDate',
    sortOrder: 'asc',
    noCount: 'true',
    registrationPicker: 'true',
    limit: 500,
    ...extra
  };
}

/** Keep the booking's current event in the dropdown even if the API list omits it. */
export function mergeBatchIntoRegistrationSelect(apiBatches, batchRow) {
  const sorted = sortEventBatchesByStartDateAsc(apiBatches || []);
  if (!batchRow?.id) return sorted;
  const id = String(batchRow.id);
  if (sorted.some((b) => String(b.id) === id)) return sorted;
  return sortEventBatchesByStartDateAsc([batchRow, ...sorted]);
}

function formatPickerDate(d) {
  if (!d) return '—';
  const x = new Date(d);
  return isNaN(x.getTime())
    ? '—'
    : x.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function registrationBatchOptionLabel(batch) {
  if (!batch) return '';
  const start = formatPickerDate(batch.startDate);
  const end = formatPickerDate(batch.endDate);
  const closed =
    batch.isActive === false || String(batch.status || '').toLowerCase() === 'inactive';
  const suffix = closed ? ' (closed)' : '';
  return `${start} to ${end}${suffix}`;
}
